import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const TESTING_CONTROL_TABLE_STATE_STORAGE_KEY = "userTestingControlList";

export const TESTING_CONTROL_LIST_COLUMN_IDS = {
    TESTING_CONTROL: "testingControl",
    TESTING_PROGRAM: "testingProgram",
    ASSIGNMENT_TYPE: "assignmentType",
    TAGS: "tags",
    SAMPLING_TAGS: "samplingTags",
} as const;

export const testingControlListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [
            {
                id: TESTING_CONTROL_LIST_COLUMN_IDS.TESTING_CONTROL,
                desc: false,
            },
        ],
    };

export const testingControlListColumnFiltersCodecMap = {
    [TESTING_CONTROL_LIST_COLUMN_IDS.TESTING_CONTROL]:
        withModeCodec(encodedArrayCodec),
    [TESTING_CONTROL_LIST_COLUMN_IDS.TESTING_PROGRAM]:
        withModeCodec(encodedArrayCodec),
    [TESTING_CONTROL_LIST_COLUMN_IDS.ASSIGNMENT_TYPE]:
        withModeCodec(encodedArrayCodec),
    [TESTING_CONTROL_LIST_COLUMN_IDS.TAGS]: withModeCodec(encodedArrayCodec),
    [TESTING_CONTROL_LIST_COLUMN_IDS.SAMPLING_TAGS]:
        withModeCodec(encodedArrayCodec),
};
